import { siteInfo } from '@/mocks/home';

const footerLinks = [
  {
    title: '内容导航',
    items: [
      { label: '热门话题', href: '#topics' },
      { label: '更新动态', href: '#updates' },
      { label: '热度榜单', href: '#ranking' },
      { label: '精选推荐', href: '#cards' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '平台介绍', href: '#about' },
      { label: '常见问答', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '媒体中心', href: '#media' },
    ],
  },
  {
    title: '专题频道',
    items: [
      { label: '电影', href: '#cards' },
      { label: '电视剧', href: '#cards' },
      { label: '动漫', href: '#cards' },
      { label: '纪录片', href: '#media' },
    ],
  },
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-2xl text-primary-500 tracking-wide">
              {siteInfo.name}
            </span>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              1080P蓝光超清4K画质电影电视剧全集免费在线观看，播放流畅不缓冲不卡顿，极致观影体验。
            </p>
            <div className="flex gap-3 mt-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-foreground-700 mb-4">{group.title}</h3>
              <ul className="space-y-3">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200">
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-foreground-700 mb-3">合作伙伴</h3>
            <p className="text-xs text-foreground-400">优质内容合作伙伴持续加入中，敬请期待。</p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有。本站内容仅供学习交流，请于下载后24小时内删除。
            </p>
            <div className="flex gap-4">
              <span className="text-xs text-foreground-400 hover:text-foreground-500 transition-colors cursor-pointer whitespace-nowrap">服务条款</span>
              <span className="text-xs text-foreground-400 hover:text-foreground-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-foreground-400 hover:text-foreground-500 transition-colors cursor-pointer whitespace-nowrap">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}